interface Config {
  [key: string]: {
    baseUrl: string
    productsUrl: string
    storeUrl: string
    googleApiUrl: string
    mode: 'development' | 'staging' | 'beta' | 'production' | 'interop'
  }
}
const config: Config = {
  development: {
    baseUrl: 'https://staging.services.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://staging.services.leadconnectorhq.com/products',
    storeUrl: 'https://staging.services.leadconnectorhq.com/store',
    googleApiUrl: 'https://staging.services.leadconnectorhq.com/common-google',
    mode: 'development',
  },
  staging: {
    baseUrl: 'https://staging.services.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://staging.services.leadconnectorhq.com/products',
    storeUrl: 'https://staging.services.leadconnectorhq.com/store',
    googleApiUrl: 'https://staging.services.leadconnectorhq.com/common-google',
    mode: 'staging',
  },
  interop: {
    baseUrl: 'https://interop.services.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://interop.services.leadconnectorhq.com/products',
    storeUrl: 'https://interop.services.leadconnectorhq.com/store',
    googleApiUrl: 'https://staging.services.leadconnectorhq.com/common-google',
    mode: 'interop',
  },
  beta: {
    baseUrl: 'https://beta-dot-highlevel-backend.appspot.com',
    productsUrl: 'https://beta-dot-highlevel-backend.appspot.com/products',
    storeUrl: 'https://beta-dot-highlevel-backend.appspot.com/store',
    googleApiUrl: 'https://staging.services.leadconnectorhq.com/common-google',
    mode: 'beta',
  },
  production: {
    baseUrl: 'https://backend.leadconnectorhq.com/store/customer-access-center',
    productsUrl: 'https://backend.leadconnectorhq.com/products',
    storeUrl: 'https://backend.leadconnectorhq.com/store',
    googleApiUrl: 'https://services.leadconnectorhq.com/common-google',
    mode: 'production',
  },
}

export default config[import.meta.env.MODE ?? 'development']
